<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" (click)="onOverlayClick($event)">
  <div class="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
    <h2 class="text-xl font-semibold mb-4">Accept Terms</h2>
    <p class="mb-4">
      Please review and accept our
      <a href="/assets/pdf/TC-220525.pdf" target="_blank" class="text-blue-600 underline">Terms & Conditions</a>
      and
      <a href="/assets/pdf/PP-220525.pdf" target="_blank" class="text-blue-600 underline">Privacy Policy</a>.
    </p>

    <label class="flex items-center mb-4 space-x-2">
      <input type="checkbox" [(ngModel)]="isAccepted" class="w-4 h-4 text-blue-600 border-gray-300 rounded" />
      <span>I agree to the terms and privacy policy</span>
    </label>

    <div class="flex justify-end space-x-2">

      <button
        mat-flat-button
        (click)="onAccept()"
        [disabled]="loading || !isAccepted"
        class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50 hover:bg-blue-700"
      >
        {{ loading ? 'Accepting...' : 'Accept' }}
      </button>
    </div>
  </div>
</div>
